import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useResidentialsQuery } from "AppQuries/master/ResidentialType/get-all-residential-type";
import { useCPFTypeQuery } from "AppQuries/master/CpfType/cpf-type";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const CPFPercentageFLIForm = () => {
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  const { data: cpfTypes } = useCPFTypeQuery({
    companyCode: watch("companyCode"),
  });

  const cpfTypeOptions = Array.isArray(cpfTypes)
    ? cpfTypes
        ?.filter((r) => r.isActive === true)
        .map((r) => ({ label: r.description, value: r.shortCode }))
    : [];

  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="cpftype"
          type="commonSelect"
          placeholder="Select CPF Type"
          className={`form-control select ${
            errors.cpftype ? "is-invalid" : ""
          }`}
          label="CPF Type"
          labelClassName="form-label"
          optionData={cpfTypeOptions}
          required={true}
          requiredMessage="Cpf type is required"
          onChange={(e) => {
            setValue("cpftype", e);
          }}
          defaultValue={watch("cpftype")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="ageFrom"
          type="text"
          placeholder="Age From"
          className={`form-control ${errors.ageFrom ? "is-invalid" : ""}`}
          label="Age From"
          labelClassName="form-label"
          required={true}
          requiredMessage="Age From is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="ageTo"
          type="text"
          placeholder="Age To"
          className={`form-control ${errors.ageTo ? "is-invalid" : ""}`}
          label="Age To"
          labelClassName="form-label"
          required={true}
          requiredMessage="Age To is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="salaryFrom"
          type="text"
          placeholder="Salary From"
          className={`form-control ${errors.salaryFrom ? "is-invalid" : ""}`}
          label="Salary From"
          labelClassName="form-label"
          required={true}
          requiredMessage="Salary From is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="salaryTo"
          type="text"
          placeholder="Salary To"
          className={`form-control ${errors.salaryTo ? "is-invalid" : ""}`}
          label="Salary To"
          labelClassName="form-label"
          required={true}
          requiredMessage="Salary To is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="employeePercentage"
          type="text"
          placeholder="Employee Percentage "
          className={`form-control ${
            errors.employeePercentage ? "is-invalid" : ""
          }`}
          label="Employee Percentage"
          labelClassName="form-label"
          required={true}
          requiredMessage="Employee Percentage is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="employerPercentage"
          type="text"
          placeholder="Employer Percentage "
          className={`form-control ${
            errors.employerPercentage ? "is-invalid" : ""
          }`}
          label="Employer Percentage"
          labelClassName="form-label"
          required={true}
          requiredMessage="Employer Percentage is required"
          defaultValue=""
        />
      </div>

      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="totalPercentage"
          type="text"
          placeholder="Total Percentage "
          className={`form-control ${
            errors.totalPercentage ? "is-invalid" : ""
          }`}
          label="Total Percentage"
          labelClassName="form-label"
          required={true}
          requiredMessage="Total Percentage is required"
          defaultValue=""
        />
      </div> */}

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="employeePercentageSalaryCeiling"
          type="text"
          placeholder="Employee Percentage Max Ceiling "
          className={`form-control ${
            errors.employeePercentageSalaryCeiling ? "is-invalid" : ""
          }`}
          label="Employee Percentage Max Ceiling"
          labelClassName="form-label"
          required={true}
          requiredMessage="Employee Percentage Max Ceiling is required"
          defaultValue=""
        />
      </div>

      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="totalCpfMaxCeiling"
          type="text"
          placeholder="Total CPF Max Ceiling"
          className={`form-control ${
            errors.totalCpfMaxCeiling ? "is-invalid" : ""
          }`}
          label="Total CPF Max Ceiling"
          labelClassName="form-label"
          required={true}
          requiredMessage="Total CPF Max Ceiling is required"
          defaultValue=""
        />
      </div> */}

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
    </div>
  );
};

export default CPFPercentageFLIForm;
